<template>
  <zl-dialog class="zl-saas" title="选择项目组成员" ref="dialog" width="665px" :close-on-click-modal="false">
    <div class="zs-member-group">
      <div class="member-checked" v-if="hasLoaded">
        <template v-for="item in checkedRecord">
          <div
            class="member-checked__item"
            :key="item"
            v-if="getMemberName(item)"
          >
            <span>{{ getMemberName(item) }}</span>
            <i class="el-icon-close" @click="deleteMember(item)"></i>
          </div>
        </template>

      </div>
      <div class="zs-member-group__list">
        <div
          class="zs-member-group__item"
          :class="activeIndex === -1 ? 'isActive' : ''"
          @click="handleClickTag(-1)"
        >
          所有人
        </div>
        <div
          class="zs-member-group__item"
          v-for="(item, index) in memberGroup"
          :key="index"
          :class="{
            'row-last': (index + 2) % 5 === 0,
            'not-first-row': index + 2 > 5,
            isActive: activeIndex === index
          }"
          @click="handleClickTag(index, item)"
        >
          <span :title="item.xmChengYuanZuName">{{ item.xmChengYuanZuName }}</span>
          <i class="el-icon-edit-outline" @click="edit(item)"></i>
        </div>
        <el-button
          type="primary"
          plain
          @click="addGroup"
          icon="el-icon-plus"
          class="zs-member-group__btn"
        >
        </el-button>
      </div>
      <el-table
        v-if="showTable"
        class="m-t-10"
        :data="memberList"
        height="300px"
      >
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="user_Name" label="姓名"></el-table-column>
        <el-table-column label="" width="100">
          <template slot="header" slot-scope="scope">
            <el-checkbox
              v-model="checkedAll"
              @change="(val) => selectAll(scope.row, val)"
            />
          </template>
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
              @change="(val) => selectChange(scope.row, val)"
            ></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="cancel">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </template>
  </zl-dialog>
</template>

<script>
import store from '@/store'
import addMemberGroup from '@/components/dialog/addMemberGroup'
export default {
  name: 'member-group',
  data() {
    return {
      hasLoaded: false,
      checkedAll: false, // 是否全选
      activeIndex: -1,
      memberList: [], // 当前组成员
      allMemberList: [], // 所有成员
      checkedRecord: [], // 选中记录
      memberGroup: [], // 组列表
      multipleSelection: [],
      timer: null,
      showTable: true,
      authType: null,
      caiGouDanWei: null
    }
  },
  created() {

  },
  methods: {
    async open(obj) {
      console.log('args--obj', obj)
      this.authType = obj.authType
      this.caiGouDanWei = obj.caiGouDanWei
      this.memberList = this.allMemberList = obj.allMemberList
      // this.getAllMember().then(() => {
      //   if (obj.args) {
      //     this.checkedRecord = obj.args.split(',')
      //     this.judgeIsCheckAll()
      //   }
      // })
      if (obj.args) {
        this.checkedRecord = obj.args.split(',')
        this.judgeIsCheckAll()
      }
      this.getData()
      return this.$refs.dialog.open()
    },
    /**
     * @description:删除成员
     */
    deleteMember(user_Guid) {
      for (const p of this.allMemberList) {
        if (p.user_Guid === user_Guid) {
          p.checked = false
          break
        }
      }
      this.selectChange({ user_Guid }, false)
    },
    cancel() {
      return this.$refs.dialog.cancel()
    },
    async confirm() {
      // 项目组成员guids 多个用“,”分隔
      const result = this.allMemberList.filter(
        (t) => this.checkedRecord.indexOf(t.user_Guid) > -1
      )
      const userGuids = result.map((t) => t.user_Guid).join(',')
      let flag = false
      // 校验用户
      if (userGuids) {
        const params = {
          userGuids: userGuids,
          authType: this.authType, // 权限类型
          caiGouDanWei: this.caiGouDanWei // 项目采购单位
        }
        await store.dispatch('validateTeamUser', params).then((res) => {
          if (!res.isValidate) {
            this.$message.error(res.message)
            flag = true
            return false
          }
        })
      }
      if (flag) return
      this.$refs.dialog.close(
        userGuids
      )
    },
    getMemberName(val) {
      const exist = this.allMemberList.find((t) => t.user_Guid === val)
      return exist && exist.user_Name
    },
    handleClickTag(val, item) {
      this.activeIndex = val
      this.checkedAll = false
      if (val === -1) {
        this.memberList = this.allMemberList
        // return
      } else {
        this.memberList = this.allMemberList.filter(
          (t) => item.chengYuanGuids.indexOf(t.user_Guid) > -1
        )
      }
      this.showTable = false
      this.$nextTick(() => {
        this.showTable = true
        this.judgeIsCheckAll()
      })
    },
    async getData() {
      // authType 10  合同管理 20 集采询单 30 小额 采购  40 订单管理
      await store.dispatch('listTeamUser', {
        authType: this.authType
      }).then((res) => {
        this.memberGroup = res
        this.hasLoaded = true
      })
    },
    // getAllMember() {
    //   return store
    //     .dispatch('queryUserByQiYeGuid', {
    //       qiYeGuid: store.state.userInfo.corpId,
    //       authType: this.authType
    //     })
    //     .then((res) => {
    //       this.memberList = this.allMemberList = res
    //       sessionStorage.setItem('memberList' + this.authTypeNew, JSON.stringify(this.memberList))
    //     })
    // },
    edit(row) {
      this.$zl.dialog.openFull(addMemberGroup, row).then(() => {
        this.getData()
        this.handleClickTag(-1)
      })
    },
    addGroup() {
      this.$zl.dialog.openFull(addMemberGroup).then(() => {
        this.getData()
        this.handleClickTag(-1)
      })
    },
    // 全选
    selectAll(row, val) {
      for (let p of this.memberList) {
        this.$set(p, 'checked', val)
        this.selectChange({ user_Guid: p.user_Guid }, val)
      }
    },
    // 判断是否需要勾选上全选
    judgeIsCheckAll() {
      for (let p of this.memberList) {
        if (this.checkedRecord.includes(p.user_Guid)) {
          this.$set(p, 'checked', true)
        }
      }
      if (!this.memberList.filter(val => !val.checked).length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    selectChange(row, val) {
      if (val && this.checkedRecord.indexOf(row.user_Guid) === -1) {
        this.checkedRecord.push(row.user_Guid)
      } else if (!val) {
        const existIndex = this.checkedRecord.findIndex(
          (t) => t === row.user_Guid
        )
        if (existIndex > -1) {
          this.checkedRecord.splice(existIndex, 1)
        }
      }
      // 单个选项全部勾选上，全选按钮须勾上
      this.judgeIsCheckAll()
    }
  }
}
</script>

<style lang="scss">
.zs-member-group {
  .zs-member-group__btn {
    padding: 0;
    height: 24px;
    width: 24px;
    text-align: center;
    border-radius: 12px;
    margin-left: 10px;
    margin-top: 7px;
  }
  .member-checked {
    background: #f5f6fa;
    margin-bottom: 10px;
    margin-top: -20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px 5px 10px 10px;
    min-height: 44px;
    box-sizing: border-box;
    &__item {
      position: relative;
      padding: 0 30px 0 10px;
      height: 24px;
      line-height: 24px;
      background: #e4e8f2;
      border-radius: 2px;
      margin-right: 5px;
      margin-top: 5px;
      border-radius: 2px;
      color: rgba(0, 0, 0, 0.65);
      .el-icon-close {
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
      }
    }
  }
  .zs-member-group__list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .zs-member-group__item {
      // position: relative;
      width: 120px;
      height: 36px;
      line-height: 36px;
      // text-align: center;
      font-weight: bold;
      background: #ffffff;
      border: 1px solid #d2d7e3;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      >span{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:first-child,
      & + .zs-member-group__item {
        border-right: 0;
      }
      &:nth-last-child(2) {
        border-right: 1px solid #d2d7e3;
      }
      // .el-icon-edit-outline {
      //   position: absolute;
      //   top: 12px;
      //   right: 11px;
      // }
    }
    .row-last {
      border-right: 1px solid #d2d7e3 !important;
    }
    .not-first-row {
      border-top: 0;
    }
    .zs-member-group__item.isActive {
      background: rgba(57, 115, 255, 0.15);
      border-radius: 1px;
      border: 1px solid #3973ff !important;
    }
  }
}
</style>
